import React, { useState, useEffect, useRef, Fragment } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Button,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Table,
  makeStyles,
  Container,
  Divider,
  CardContent,
  CardHeader,
  Grid,
  TextField,
  MenuItem,
  InputLabel
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from 'yup';
import {
  DatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import xlsx from 'json-as-xlsx';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ReactToPrint from 'react-to-print';
import CreatePDF from './CreatePDF';
import { endOfMonth, getMonth } from 'date-fns';
import { LoadingComponent } from '../../../../utils/newLoader';
import { useAlert } from 'react-alert';
import CreateBankWiseCustomerPDF from './CreateBankWiseCustomerPDF';
import TablePagination from '@material-ui/core/TablePagination';
import { upperCase } from 'lodash';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  row: {
    marginTop: '1rem'
  },
  colorCancel: {
    backgroundColor: 'red'
  },
  colorRecordAndNew: {
    backgroundColor: '#FFBE00'
  },
  colorRecord: {
    backgroundColor: 'green'
  }
}));

const screenCode = 'BANKCUSTOMERDETAILSREPORT';

export default function BankCustomerDetailsReport(props) {
  const [title, setTitle] = useState('Bank Customer Report');
  const alert = useAlert();
  const classes = useStyles();
  const [groups, setGroups] = useState();
  const [FactoryList, setFactoryList] = useState([]);
  const [routes, setRoutes] = useState();
  const [branches, setBranches] = useState();
  const [bankList, setBankList] = useState([]);
  const [selectedDate, setSelectedDate] = useState();
  const [selectedDatePDF, setSelectedDatePDF] = useState();
  const [bankCustomerData, setBankCustomerData] = useState([]);
  const [bankCustomerList, setBankCustomerList] = useState({
    groupID: '0',
    factoryID: '0',
    routeID: '0',
    bankID: '0',
    branchID: '0',
    year: '',
    month: ''
  });
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    factoryName: '0',
    groupName: '0',
    monthName: '',
    year: '',
    monthName: '',
    routeName: ''
  });
  let bankName = bankList[bankCustomerList.bankID - 1] == undefined ? "All Banks" : (bankList[bankCustomerList.bankID - 1]).bankName;

  let branchName = branches && bankCustomerList && bankCustomerList.branchID !== undefined
    ? branches[bankCustomerList.branchID - 1]
    : 'Unknown Branch';

  const bankCode = bankCustomerData.length > 0 ? bankCustomerData[0].bankCode : '';
  const branchCode = bankCustomerData.length > 0 ? bankCustomerData[0].branchCode : '';

  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });

  const [maxDate, setMaxDate] = useState(new Date());
  const [month, setMonth] = useState(['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'])
  const navigate = useNavigate();
  const csvHeaders = [];
  const componentRef = useRef();
  const componentRef1 = useRef();
  const [totalAmount, setTotalAmount] = useState();
  const [totalAmountpdf, setTotalAmountpdf] = useState();
  const [alertCount, setAlertCount] = useState({
    count: 0
  });
  const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(0);

  const date = new Date(selectedDate);
  const todayDate = new Date();
  const monthnew = upperCase(date.toLocaleString('default', { month: 'long' }) == 'Invalid Date' ? todayDate.toLocaleString('default', { month: 'long' }) : date.toLocaleString('default', { month: 'long' }));
  const yearNew = date.getFullYear();

  useEffect(() => {
    trackPromise(getPermission());
    trackPromise(getGroupsForDropdown());
    setPage(0);
  }, []);

  useEffect(() => {
    if (bankCustomerList.factoryID > 0 && bankCustomerList.groupID > 0) {
      trackPromise(GetBalancePaymentYearMonthForDropDown());
    }
  }, [bankCustomerList.factoryID, bankCustomerList.groupID]);

  useEffect(() => {
    trackPromise(getRoutesByFactoryID());
    setBankCustomerData([]);
  }, [bankCustomerList.factoryID]);

  useEffect(() => {
    trackPromise(getBanksForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(getFactoriesForDropdown());
    setRoutes([]);
  }, [bankCustomerList.groupID]);

  useEffect(() => {
    getBranchesForDropdown();
    setBankCustomerList(prev => ({ ...prev, branchID: '0' }));
    setBankCustomerData([])
  }, [bankCustomerList.bankID]);

  useEffect(() => {
    setBankCustomerList(prev => ({
      ...prev,
      bankID: '0',
      branchID: '0'
    }));
    trackPromise(checkISBalancePaymentCompleted());
  }, [bankCustomerList.groupID, bankCustomerList.factoryID]);

  useEffect(() => {
    setAlertCount({ count: alertCount.count + 1 });
  }, [bankCustomerList.year]);

  useEffect(() => {
    setBankCustomerList((prev) => ({ ...prev, routeID: '0' }))
  }, [bankCustomerList.groupID, bankCustomerList.factoryID]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWBANKCUSTOMERDETAILSREPORT');
    if (isAuthorized === undefined) navigate('/404');
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');
    setPermissions({ ...permissionList, isGroupFilterEnabled: isGroupFilterEnabled !== undefined, isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined });
    setBankCustomerList({ ...bankCustomerList, groupID: parseInt(tokenService.getGroupIDFromToken()), factoryID: parseInt(tokenService.getFactoryIDFromToken()) });
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroups(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(
      bankCustomerList.groupID
    );
    setFactoryList(factories);
  }

  async function getRoutesByFactoryID() {
    const route = await services.getRoutesForDropDown(bankCustomerList.factoryID);
    setRoutes(route);
  }

  async function getBanksForDropdown() {
    const bank = await services.getBanksForDropdown();
    setBankList(bank);
  }

  async function getBranchesForDropdown() {
    const branch = await services.getBranchesByBankID(parseInt(bankCustomerList.bankID));
    setBranches(branch);
  }

  async function GetBalancePaymentYearMonthForDropDown() {
    var response = await services.GetBalancePaymentYearMonth(bankCustomerList.groupID, bankCustomerList.factoryID);
    const applicableYear = parseInt(response.applicableYear);
    const applicableMonth = parseInt(response.applicableMonth) - 1;
    const selectedDate = new Date(applicableYear, applicableMonth);
    setSelectedDate(selectedDate);
    setSelectedDatePDF(response);
  };

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items;
  }

  function handleDateChange(date) {
    let monthNames = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'];
    var month = date.getUTCMonth() + 1;
    var year = date.getUTCFullYear();
    let monthName = monthNames[month - 1];
    setSelectedSearchValues({ ...selectedSearchValues, monthName: monthName });
    setBankCustomerList({ ...bankCustomerList, month: month.toString(), year: year.toString() });
    if (selectedDate != null) {
      var prevMonth = selectedDate.getUTCMonth() + 1;
      var prevyear = selectedDate.getUTCFullYear();
      if ((prevyear == year && prevMonth != month) || prevyear != year) setSelectedDate(date);
    } else setSelectedDate(date);
    setBankCustomerData([]);
  }

  async function GetDetails() {
    if (bankCustomerList.groupID > 0 && bankCustomerList.factoryID > 0 && selectedDate != null && selectedDate !== '') {
      const applicableYear = selectedDate.getFullYear().toString();
      const applicableMonth = (selectedDate.getMonth() + 1).toString();
      let model = {
        groupID: parseInt(bankCustomerList.groupID),
        factoryID: parseInt(bankCustomerList.factoryID),
        routeID: parseInt(bankCustomerList.routeID),
        bankID: parseInt(bankCustomerList.bankID),
        branchID: parseInt(bankCustomerList.branchID),
        applicableMonth: applicableMonth,
        applicableYear: applicableYear
      };
      getSelectedDropdownValuesForReport(model);
      let total = 0;
      const customerData = await services.GetBankCustomerDetails(model);
      if (customerData.statusCode === 'Success' && customerData.data !== null) {
        setBankCustomerData(customerData.data);
        createDataForExcel(customerData.data);
        customerData.data.forEach((x) => { total = total + parseFloat(x.amount); });
        setTotalAmount(total);
        setTotalAmountpdf(total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        if (customerData.data.length === 0 && alertCount.count > 1) alert.error('NO RECORDS TO DISPLAY');
      }
    }
  }

  async function createDataForExcel(array) {
    var res = [];
    if (array != null) {
      array.map(x => {
        var vr = {
          "Route": x.routeName,
          "Bank - Bank Code": `${x.bankName} - ${x.bankCode}`,
          "Branch - Branch Code": `${x.branchName} - ${x.branchCode}`,
          "RegNo": x.registrationNumber,
          "Name": x.name,
          "AccountNumber": x.accountNumber,
          "Amount": x.amount
        };
        res.push(vr);
      });
    }
    return res;
  }

  async function createFile() {
    var file = await createDataForExcel(bankCustomerData);
    var settings = {
      sheetName: 'Bank Customer Details Report',
      fileName: 'Bank Customer Details Report - ' + groups[bankCustomerList.groupID] + ' - ' + selectedSearchValues.factoryName + ' - ' + monthnew + "-" + yearNew + ' (' + bankName + ')',
      writeOptions: {}
    };
    let keys = Object.keys(file[0]);
    let tempcsvHeaders = csvHeaders;
    keys.map((sitem, i) => { tempcsvHeaders.push({ label: sitem, value: sitem }); });
    file.push({});
    let total = { "Route": "Total", "Amount": totalAmount }
    file.push(total)
    file.push({});
    let filterData = { "Route": "Group: " + groups[bankCustomerList.groupID], "Bank - Bank Code": "Factory: " + FactoryList[bankCustomerList.factoryID], "RegNo": "Route: " + routes[bankCustomerList.routeID] === undefined ? "All Routes" : routes[bankCustomerList.routeID], }
    file.push(filterData);
    let filterDate = { "Route": "Month: " + month[(selectedDate.getMonth() + 1).toString() - 1], "Bank - Bank Code": "Year: " + selectedDate.getFullYear().toString() }
    file.push(filterDate);
    let filterDetail = { "Route": "Bank: " + (bankCustomerList.bankID == '0' ? "All Banks" : bankCustomerData[0].bankName), "Bank - Bank Code": "Branch: " + (bankCustomerList.branchID == '0' ? "All Branch" : bankCustomerData[0].branchName), }
    file.push(filterDetail);
    let dataA = [{ sheet: 'Bank Customer Details Report', columns: tempcsvHeaders, content: file }];
    xlsx(dataA, settings);
  }

  async function checkISBalancePaymentCompleted() {
    const response = await services.CheckISBalancePaymentCompleted(bankCustomerList.groupID, bankCustomerList.factoryID);
    const bDate = moment(response.data.lastBalancePaymentSchedule, moment.defaultFormat).toDate();
    var result = endOfMonth(bDate);
    setMaxDate(result);
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>{titleName}</Grid>
      </Grid>
    );
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value;
    if([e.target.name] == 'groupID'){
      setBankCustomerList({ ...bankCustomerList, [e.target.name]: value, factoryID: '0', routeID: '0' });
    } else {
      setBankCustomerList({ ...bankCustomerList, [e.target.name]: value });
    }
    setBankCustomerData([]);
  }

  function handleSearchDropdownChange(data, e) {
    if (data === undefined || data === null) {
      setBankCustomerList({ ...bankCustomerList, bankID: '0' });
      return;
    } else {
      var valueV = data['bankID'];
      setBankCustomerList({ ...bankCustomerList, bankID: valueV.toString() });
    }
  }

  function handleSearchDropdownBranch(data, e) {
    if (data === undefined || data === null) {
      setBankCustomerList({ ...bankCustomerList, branchID: '0' });
      return;
    } else {
      var valueV = data['branchID'];
      setBankCustomerList({ ...bankCustomerList, branchID: valueV.toString() });
    }
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: groups[searchForm.groupID],
      factoryName: FactoryList[searchForm.factoryID],
      routeName: routes[searchForm.routeID],
      month: searchForm.month,
      year: searchForm.year
    });
  }

  const handleLimitChange = (event) => { setLimit(event.target.value); };
  const handlePageChange = (event, newPage) => { setPage(newPage); };

  const getPageMargins = () => {
    return `@media print {
      @page { size: A4 Landscape !important; background-color: white !important; }
      body { transform-origin: top left; background-color: white !important; }
    }`;
  };

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: bankCustomerList.groupID,
              factoryID: bankCustomerList.factoryID,
              bankID: bankCustomerList.bankID,
              selectedDate: selectedDate
            }}
            validationSchema={Yup.object().shape({
              groupID: Yup.number().required('Group is required').min('1', 'Group is required'),
              factoryID: Yup.number().required('Factory is required').min('1', 'Factory is required'),
              selectedDate: Yup.string().required('Select applicable month').nullable()
            })}
            enableReinitialize
          >
            {({ errors, handleBlur, handleSubmit, touched }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="groupID">Group *</InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={e => handleChange(e)}
                              value={bankCustomerList.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}
                              size="small"
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(groups)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(
                                touched.factoryID && errors.factoryID
                              )}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={e => handleChange(e)}
                              value={bankCustomerList.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                              size="small"
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="routeID">Route</InputLabel>
                            <TextField
                              select
                              fullWidth
                              name="routeID"
                              onBlur={handleBlur}
                              onChange={e => handleChange(e)}
                              value={bankCustomerList.routeID}
                              variant="outlined"
                              id="routeID"
                              size="small"
                            >
                              <MenuItem value="0">--Select Routes--</MenuItem>
                              {generateDropDownMenu(routes)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={8}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <DatePicker
                                error={Boolean(touched.selectedDate && errors.selectedDate)}
                                helperText={touched.selectedDate && errors.selectedDate}
                                autoOk
                                fullWidth
                                id="selectedDate"
                                variant="inline"
                                openTo="month"
                                views={['year', 'month']}
                                label="Year and Month *"
                                value={selectedDate}
                                maxDate={maxDate}
                                disableFuture={true}
                                onChange={date => handleDateChange(date)}
                                size="small"
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>

                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="bankID">Bank</InputLabel>
                            <Autocomplete
                              id="bankID"
                              options={bankList}
                              key={bankCustomerList.factoryID}
                              getOptionLabel={option => option.bankName.toString()}
                              onChange={(e, value) => handleSearchDropdownChange(value, e)}
                              defaultValue={null}
                              renderInput={params => (
                                <TextField
                                  {...params}
                                  variant="outlined"
                                  name="bankID"
                                  fullWidth
                                  value={bankCustomerList.bankID}
                                  size="small"
                                />
                              )}
                            />
                          </Grid>

                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="branchID">Branch</InputLabel>
                            <Autocomplete
                              id="branchID"
                              options={branches}
                              key={bankCustomerList.bankID}
                              getOptionLabel={option => option.branchName.toString()}
                              onChange={(e, value) => handleSearchDropdownBranch(value, e)}
                              defaultValue={null}
                              renderInput={params => (
                                <TextField
                                  {...params}
                                  variant="outlined"
                                  name="branchID"
                                  fullWidth
                                  value={bankCustomerList.branchID}
                                  size="small"
                                />
                              )}
                            />
                          </Grid>
                          <Grid container justify="flex-end">
                            <Box pr={2}>
                              <Button
                                color="primary"
                                variant="contained"
                                type="submit"
                                onClick={() => trackPromise(GetDetails())}
                              >
                                Search
                              </Button>
                            </Box>
                          </Grid>
                        </Grid>
                        <br /><br /><br /><br />

                        <Box minWidth={1050}>
                          {bankCustomerData.length > 0 ? (
                            <TableContainer>
                              <Table aria-label="caption table" size="small">
                                <TableHead>
                                  <TableRow>
                                    <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Route</TableCell>
                                    <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Bank & Bank Code</TableCell>
                                    <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Branch & Branch Code</TableCell>
                                    <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>RegNo</TableCell>
                                    <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Name</TableCell>
                                    <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Account Number</TableCell>
                                    <TableCell align={'right'} style={{ border: "1px solid #ccc" }}>Amount(Rs)</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {bankCustomerData.slice(page * limit, page * limit + limit).map((data, index) => (
                                    <TableRow key={index}>
                                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>{data.routeName}</TableCell>
                                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>{data.bankName} - {data.bankCode}</TableCell>
                                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>{data.branchName} - {data.branchCode}</TableCell>
                                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>{data.registrationNumber}</TableCell>
                                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>{data.name}</TableCell>
                                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>{data.accountNumber}</TableCell>
                                      <TableCell align={'right'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>{data.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                                <TableRow style={{ border: "1px solid #ccc" }}>
                                  <TableCell align={'left'} style={{ borderBottom: "none" }}><b>Total</b></TableCell>
                                  <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}></TableCell>
                                  <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}></TableCell>
                                  <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}></TableCell>
                                  <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}></TableCell>
                                  <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}></TableCell>
                                  <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none", borderLeft: "1px solid #ccc" }}>
                                    <b>{bankCustomerData.reduce((sum, row) => sum + row.amount, 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>
                                  </TableCell>
                                </TableRow>
                              </Table>
                              <TablePagination
                                component="div"
                                count={bankCustomerData.length}
                                onChangePage={handlePageChange}
                                onChangeRowsPerPage={handleLimitChange}
                                page={page}
                                rowsPerPage={limit}
                                rowsPerPageOptions={[5, 10, 25]}
                              />
                            </TableContainer>
                          ) : null}
                        </Box>
                      </CardContent>
                      {bankCustomerData.length > 0 ? (
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          {bankCustomerList.bankID != 0 ? (
                            <>
                              <ReactToPrint
                                documentTitle={'Bank Customer Detail List - ' + groups[bankCustomerList.groupID] + ' - ' + selectedSearchValues.factoryName + ' - ' + monthnew + "-" + yearNew + ' (' + bankName + ')'}
                                trigger={() => (
                                  <Button
                                    color="primary"
                                    id="btnCancel"
                                    variant="contained"
                                    style={{ marginRight: '1rem' }}
                                    className={classes.colorCancel}
                                    size="small"
                                  >
                                    Bank list
                                  </Button>
                                )}
                                pageStyle={getPageMargins()}
                                content={() => componentRef1.current}
                              />
                            </>
                          ) : null}
                          <div>&nbsp;</div>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={createFile}
                            size="small"
                          >
                            EXCEL
                          </Button>
                          <div>&nbsp;</div>
                          <ReactToPrint
                            documentTitle={'Bank Customer Details Report - ' + groups[bankCustomerList.groupID] + ' - ' + selectedSearchValues.factoryName + ' - ' + monthnew + "-" + yearNew + ' (' + bankName + ')'}
                            trigger={() => (
                              <Button
                                color="primary"
                                id="btnCancel"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorCancel}
                                size="small"
                              >
                                PDF
                              </Button>
                            )}
                            pageStyle={getPageMargins()}
                            content={() => componentRef.current}
                          />
                          <div hidden={true}>
                            <CreatePDF
                              ref={componentRef}
                              BankCustomerList={bankCustomerList}
                              TotalAmount={totalAmount}
                              totalAmountpdf={totalAmountpdf}
                              BankCustomerSearchData={selectedSearchValues}
                              BankCustomerData={bankCustomerData}
                              selectedDatePDF={selectedDatePDF}
                              monthnew={monthnew}
                              yearNew={yearNew}
                              bankName={bankName}
                              branchName={branchName}
                              branchCode={branchCode}
                              bankCode={bankCode}
                            />

                            <CreateBankWiseCustomerPDF
                              ref={componentRef1}
                              BankCustomerList={bankCustomerList}
                              TotalAmount={totalAmount}
                              totalAmountpdf={totalAmountpdf}
                              BankCustomerSearchData={selectedSearchValues}
                              BankCustomerData={bankCustomerData}
                              selectedDatePDF={selectedDatePDF}
                            />
                          </div>
                        </Box>
                      ) : null}
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}